import { is_element } from "./is_element"
import { is_function } from "./is_function"
import { is_iterator } from "./is_iterator"
import { is_object } from "./is_object"

/**
 * Checks if value is a plain object mapping.
 *
 * True for plain objects, false for arrays, functions, iterators, and DOM elements.
 *
 * @param iterable - Value to check
 * @returns True if plain object mapping
 */
export const is_mapping = iterable =>
  is_object(iterable) &&
  !is_iterator(iterable) &&
  !is_function(iterable) &&
  !is_element(iterable)
